import { pick, useT } from "../i18n/index.js";
import { formationEffects } from "./formationModel.js";
import type { SquadSlotKey, UnitView } from "./types.js";

export function FormationPreview({ before, after, units }: {
  before: Record<SquadSlotKey, string | null>; after: Record<SquadSlotKey, string | null>; units: ReadonlyMap<string, UnitView>;
}) {
  const t = useT(), current = formationEffects(before, units), draft = formationEffects(after, units);
  const gained = draft.chemistry.doctrines.filter(d => !current.chemistry.doctrines.includes(d));
  const lost = current.chemistry.doctrines.filter(d => !draft.chemistry.doctrines.includes(d));
  return <section className="formation-draft" data-testid="formation-preview" aria-label={pick({de:"Wirkung nach dem Speichern",en:"Effects after saving"})}>
    <strong>{pick({de:"Nach dem Speichern",en:"After saving"})}</strong>
    <div className="formation-draft-values">
      <span>{t("units.chemistry")} <b data-testid="preview-chemistry">{current.chemistry.percent}% → {draft.chemistry.percent}%</b></span>
      <span>{pick({de:"Startmoral",en:"Starting morale"})} <b data-testid="preview-morale">{current.morale?.score ?? "—"} → {draft.morale?.score ?? "—"}</b></span>
      <span>{pick({de:"Moralwirkung",en:"Morale effect"})} <b>{draft.morale ? `${draft.morale.atkPct >= 0 ? "+" : ""}${draft.morale.atkPct}% ATK` : "—"}</b></span>
    </div>
    {gained.map(d => <p key={d} className="formation-draft-gain">+ {t(`doctrine.${d}`)} · {t(`doctrine.${d}.hint`)}</p>)}
    {lost.map(d => <p key={d} className="formation-draft-loss">− {t(`doctrine.${d}`)} · {t(`doctrine.${d}.hint`)}</p>)}
  </section>;
}
